var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "inherit"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.552 198.748l-9.423-9.423a3.385 3.385 0 0 0-4.782 0l-9.423 9.423a.635.635 0 0 0 0 .9.65.65 0 0 0 .9 0l.811-.811v9.929a2.058 2.058 0 0 0 2.056 2.055h16.1a2.058 2.058 0 0 0 2.055-2.055v-9.929l.811.811a.65.65 0 0 0 .9 0 .636.636 0 0 0-.005-.9zm-14.21 10.8v-6.09a.977.977 0 0 1 .975-.975h2.841a.977.977 0 0 1 .976.975v6.09zm11.232-.786a.787.787 0 0 1-.786.786H188.4v-6.09a2.247 2.247 0 0 0-2.245-2.245h-2.841a2.247 2.247 0 0 0-2.245 2.245v6.09h-4.385a.787.787 0 0 1-.786-.786v-11.2l7.343-7.343a2.114 2.114 0 0 1 2.987 0l7.343 7.343z",
    transform: "translate(-163.738 -178.916)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e7e6b8a2.svg";
export { ForwardRef as ReactComponent };